import { getCookie } from "../Store/Storage/Cookies";

export const AllUrl = {
  //Local
  // baseUrl: "http://192.168.1.208:5000/em_api/",

  //Production
  // baseUrl: "http://cbe.themaestro.in:8021/em_api",
  // "homepage": "http://cbe.themaestro.in:8021/em_docs"

  //****change root baseurl in both login and logout*******//
  SALT_KEY: "A0322A@B&H@R!!akLLo012VSzXycAA1",

  baseUrl: getCookie("MconnectEnergyLoginData")
    ? JSON.parse(getCookie("MconnectEnergyLoginData"))?.base_url
    : //: "http://192.168.1.117:8001",
      "https://mcroot.themaestro.in/api",

  // "http://cbe.themaestro.in:8021/root_mconnect",
  // "http://cbe.themaestro.in:8021/root_demo_mconnect"
  // "http://192.168.1.108/root_demo_mconnect"
  // "https://mcroot.themaestro.in/api"

  // "homepage": "http://cbe.themaestro.in:8021/mpower_demo",
  // "homepage": "http://cbe.themaestro.in:8021/mpower",
  // "homepage": "https://mpoweri4.com/login/",
};

export const SaltKeys = {
  developmentSaltKey: "A0322A@B&H@R!!akLLo012VSzXycAA1",
};
